<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-card-text class="text-center" v-show="verifyCardHide">
          <div class="py-1">
            <h5 class="font-weight-bold">Admin</h5>
            <v-text-field type="password" label="Passcode" v-model="passCode" />
            <v-btn block color="primary" @click="verify"> Verify </v-btn>
          </div>
        </v-card-text>
        <v-card-text class="text-center" v-show="registerCardHide">
          <div class="py-1">
            <v-avatar tile size="200">
              <img
                src="@/assets/images/illustrations/posting_photo.svg"
                alt=""
              />
            </v-avatar>
            <h5 class="font-weight-bold">LETS GET STARTED!</h5>
            <p class="text--disabled font-weight-medium">
              Create an account to POS now
            </p>
          </div>
          <v-text-field
            label="Your name"
            v-model="name"
            :error-messages="nameErrors"
            required
            @input="$v.name.$touch()"
            @blur="$v.name.$touch()"
          />
          <v-text-field
            label="Email"
            v-model="email"
            :error-messages="emailErrors"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          />

          <v-text-field
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            v-model="password"
            @click:append="show = !show"
            :error-messages="passwordErrors"
            required
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>

          <v-text-field
            label="Business Name"
            v-model="bName"
            :error-messages="bNameErrors"
            required
            @input="$v.bName.$touch()"
            @blur="$v.bName.$touch()"
          />
          <v-select
            v-model="selectedPlan"
            :items="items"
            label="Subscription Plan"
            :item-text="getFieldText"
            return-object
            :error-messages="selectedPlanErrors"
            required
            @input="$v.selectedPlan.$touch()"
            @blur="$v.selectedPlan.$touch()"
          ></v-select>

          <v-select
            v-model="selectedDealer"
            :items="dealers"
            label="Dealer"
            item-text="company"
            return-object
            :error-messages="selectedDealerErrors"
            required
            @input="$v.selectedDealer.$touch()"
            @blur="$v.selectedDealer.$touch()"
          ></v-select>

          <div>
            <v-row>
              <v-col>
                <v-text-field
                  label="Discount Rate"
                  v-model="dRate"
                  type="number"
                  :error-messages="dRateErrors"
                  @input="$v.dRate.$touch()"
                  @blur="$v.dRate.$touch()"
                />
              </v-col>
              <v-col>
                <v-text-field
                  label="Commission Rate"
                  v-model="cRate"
                  type="number"
                  :error-messages="cRateErrors"
                  @input="$v.cRate.$touch()"
                  @blur="$v.cRate.$touch()"
                />
              </v-col>
            </v-row>
          </div>

          <v-checkbox
            v-model="checkbox"
            :error-messages="checkboxErrors"
            required
            @input="$v.checkbox.$touch()"
            @blur="$v.checkbox.$touch()"
          >
            <template v-slot:label>
              <div>
                I agree with
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a
                      href="https://channelsoft.com.my/privacy-policy/"
                      target="_blank"
                      @click.stop
                      v-on="on"
                    >
                      terms and conditions
                    </a>
                  </template>
                  Opens in new window
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>

          <v-btn
            class="mb-4"
            block
            @click="register"
            :loading="btnLoading"
            color="primary"
            >Sign Up</v-btn
          >
          <div class="">
            Already have an account ?
            <v-btn text small color="primary" to="/app/sessions/login"
              >Sign In</v-btn
            >
          </div>
        </v-card-text>

        <!-- error password snackbar  -->
        <v-snackbar v-model="snackbar" top :color="sColor">
          {{ message }}
          <template v-slot:action="{ attrs }">
            <v-btn color="" text v-bind="attrs" @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </base-card>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue, email } from "vuelidate/lib/validators";

export default {
  name: "signup",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Register",
  },
  mixins: [validationMixin],

  validations: {
    name: { required },
    email: {
      required,
      email,
      exist(value) {
        if (value === "") return true;
        return new Promise((resolve, reject) => {
          const params = new URLSearchParams();
          params.append("checkEmailExist", "done");
          params.append("email", this.email);
          axios({
            method: "post",
            url: this.domain + "/user/index.php",
            data: params,
          })
            .then((response) => {
              value = 2;
              const email = response.data.status;
              resolve(value === email);
            })
            .catch(() => reject(false));
        });
      },
    },
    password: { required, minLength: minLength(6) },
    bName: { required },
    selectedPlan: { required },
    selectedDealer: { required },
    dRate: { minValue: minValue(0) },
    cRate: { minValue: minValue(0) },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },

  data() {
    return {
      domain: BASEURL,
      show: false,
      checkbox: false,
      email: "",
      message: "",
      password: "",
      name: "",
      bName: "",
      passCode: "",
      correctPasscode: "",
      registerCardHide: false,
      verifyCardHide: true,
      loading: false,
      snackbar: false,
      sColor: "",
      emailExist: "",
      items: [],
      dealers: [],
      selectedPlan: "",
      selectedDealer: "",
      btnLoading: false,
      dRate: "",
      cRate: "5",
    };
  },

  created() {
    this.getAllSubscriptionPlan();
    this.getAllDealer();
    this.fetchPasscode();
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email");
      !this.$v.email.required && errors.push("Email is required");
      !this.$v.email.exist && errors.push("Email already exists");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required.");
      !this.$v.password.minLength &&
        errors.push("Password must at least 6 character.");
      return errors;
    },

    bNameErrors() {
      const errors = [];
      if (!this.$v.bName.$dirty) return errors;
      !this.$v.bName.required && errors.push("Business Name is required.");
      return errors;
    },

    selectedPlanErrors() {
      const errors = [];
      if (!this.$v.selectedPlan.$dirty) return errors;
      !this.$v.selectedPlan.required &&
        errors.push("Subscription Plan is required.");
      return errors;
    },

    selectedDealerErrors() {
      const errors = [];
      if (!this.$v.selectedDealer.$dirty) return errors;
      !this.$v.selectedDealer.required && errors.push("Dealer is required.");
      return errors;
    },
    dRateErrors() {
      const errors = [];
      if (!this.$v.dRate.$dirty) return errors;

      !this.$v.dRate.minValue && errors.push("Minimum Discount rate is 0");

      return errors;
    },

    cRateErrors() {
      const errors = [];
      if (!this.$v.cRate.$dirty) return errors;

      !this.$v.cRate.minValue && errors.push("Minimum Commission rate is 0");
      return errors;
    },

    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      !this.$v.checkbox.checked && errors.push("You must agree to continue!");

      return errors;
    },
  },

  watch: {
    selectedDealer() {
      this.dRate = this.selectedDealer.discount_rate;
  
    },
  },

  methods: {
    async fetchPasscode() {
      try {
        const response = await axios.get("/api/passcode");
        this.correctPasscode = response.data;
      } catch (error) {
        console.error("Failed to fetch mock passcode", error);
      }
    },

    verify() {
      if (this.passCode == this.correctPasscode) {
        this.snackbar = true;
        this.sColor = "success";
        this.message = "Verified Admin";
        this.verifyCardHide = false;
        this.registerCardHide = true;
      } else {
        this.snackbar = true;
        this.sColor = "danger";
        this.message = "Not Authorised Admin";
      }
    },

    register() {
      this.btnLoading = true;
      var moment = require("moment");
      var startDate = moment().format("YYYY-MM-DD");
      var endDate = moment(startDate)
        .add(this.selectedPlan.duration, "M")
        .format("YYYY-MM-DD");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const params = new URLSearchParams();
        params.append("company_register_new", "done");
        params.append("user_name", this.name);
        params.append("email", this.email);
        params.append("password", this.password);
        params.append("company_name", this.bName);
        params.append("subscription_plan_id", this.selectedPlan.id);
        params.append(
          "subscription_package",
          this.selectedPlan.subscription_package
        );
        params.append("subscription_fee", this.selectedPlan.subscription_fee);
        params.append("duration", this.selectedPlan.duration);
        params.append("branch_amount", this.selectedPlan.branch_amount);
        params.append("dealer_id", this.selectedDealer.dealer_id);
        params.append("discount_rate", this.dRate ? this.dRate : 0);
        params.append("commision_rate", this.cRate ? this.cRate : 0);
        params.append("sale_by", this.selectedDealer.company);
        params.append("based_amount", (this.selectedPlan.subscription_fee*((100-this.dRate)/100)).toFixed(2));
        params.append("commision_amount", ((this.selectedPlan.subscription_fee*((100-this.dRate)/100))*(this.cRate/100)).toFixed(2));
        params.append("start_date", startDate);
        params.append("end_date", endDate);
        axios({
          method: "post",
          url: this.domain + "/company/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.snackbar = true;
              this.sColor = "success";
              this.message = "Successfully register account. wait for login...";
              this.btnLoading = false;
              this.login();
            } else {
              this.snackbar = true;
              this.sColor = "danger";
              this.message = "Something went wrong. Please try again";
              this.btnLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getAllSubscriptionPlan() {
      const params = new URLSearchParams();
      params.append("readAllSubscription", "done");
      axios({
        method: "post",
        url: this.domain + "/subscription/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.items = response.data.subscription;
          } else {
            this.items = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllDealer() {
      const params = new URLSearchParams();
      params.append("getAllDealer", "done");
      axios({
        method: "post",
        url: this.domain + "/company/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.dealers = response.data.dealer;
          } else {
            this.dealers = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getFieldText(item) {
      return `${item.subscription_package} - RM${item.subscription_fee} - ${item.duration} months - ${item.branch_amount} branch`;
    },
    login() {
      const params = new URLSearchParams();
      params.append("login", "done");
      params.append("email", this.email);
      params.append("password", this.password);

      axios({
        method: "post",
        url: this.domain + "/user/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var CryptoJS = require("crypto-js");

            // Encrypt
            var ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify(response.data.user),
              "secret key 123"
            ).toString();

            localStorage.setItem("userInfo", ciphertext);
            setTimeout(() => {
              this.$router.push("/");
            }, 1000);
          } else {
            this.snackbar = true;
            this.sColor = "danger";
            this.message = "Auto login failed. Please sign in manually";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  background-color: #242939 !important;
  display: flex;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
